module.exports = __webpack_public_path__ + "static/img/son8.724d4190.png";